import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CatalogState, StateWithCatalog } from '../catalog-state';
import { getFeatureState } from './feature.selector';

export const getCatalogRootNodeIdState: MemoizedSelector<
  StateWithCatalog,
  StateUtils.LoaderState<string>
> = createSelector(getFeatureState, (state: CatalogState) => state.rootNodeId);

export const getCatalogRootNodeIdValue: MemoizedSelector<StateWithCatalog, string> = createSelector(
  getCatalogRootNodeIdState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderValueSelector(state),
);

export const getCatalogRootNodeIdLoading: MemoizedSelector<StateWithCatalog, boolean> = createSelector(
  getCatalogRootNodeIdState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderLoadingSelector(state),
);

export const getCatalogRootNodeIdError: MemoizedSelector<StateWithCatalog, boolean> = createSelector(
  getCatalogRootNodeIdState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderErrorSelector(state),
);

export const getCatalogRootNodeIdSuccess: MemoizedSelector<StateWithCatalog, boolean> = createSelector(
  getCatalogRootNodeIdState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderSuccessSelector(state),
);
